import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { SignaturePadModule } from 'angular2-signaturepad';
import { SignaturePanelModule } from '../signature-panel/signature-panel.module';
import { QrCodeSignFieldComponent } from './qr-code-sign-field/qr-code-sign-field.component';
import { QRCodeDialogComponent } from './qrcode-dialog/qrcode-dialog.component';
import { SignButtonComponent } from './sign-button/sign-button.component';
import { SignPanelComponent } from './sign-panel/sign-panel.component';
import { UnterschriftDialogComponent } from './unterschrift-dialog/unterschrift-dialog.component';
import { UnterschriftenRoutingModule } from './unterschriften.routing.module';
import { QrCodeModule } from 'ng-qrcode';

@NgModule({
    declarations: [
        SignButtonComponent,
        QRCodeDialogComponent,
        SignPanelComponent,
        QrCodeSignFieldComponent,
        UnterschriftDialogComponent,
    ],
    imports: [
        CommonModule,
        UnterschriftenRoutingModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatTabsModule,
        SignaturePadModule,
        SignaturePanelModule,
        QrCodeModule,
    ],
    exports: [SignButtonComponent, SignPanelComponent, QrCodeSignFieldComponent],
})
export class UnterschriftenModule {}
